import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';
import { TeCuidamosUserData, User } from '../../../core/models/user';
import { ContextService } from '../../../core/services/core/context.service';
import { NavigationHelper } from '../../../core/services/core/navigation-helper.service';
import { TecuidamosService } from '../../../core/services/core/tecuidamos.service';
import { TeCuidamosHelper } from '../../../core/services/helpers/teCuidamos-helper.service';
import { AllFeatureFlags } from '@models/mmobile';
import { AuthService } from '@core/services/core/auth/auth.service';
@Component({
  selector: 'app-tecuidamos-home',
  templateUrl: './tecuidamos-home.component.html',
  styleUrls: ['./tecuidamos-home.component.scss']
})
export
 class TecuidamosHomeComponent implements OnInit {
  @Output() navigateTo = new EventEmitter();
  cardImageFrontSafeResource: SafeResourceUrl;
  teCuidamosState: TeCuidamosUserData;
  teCuidamosSavia: boolean;
  user: User;

  constructor(
    public nav: NavigationHelper,
    public ctx: ContextService,
    public auth: AuthService,
    private teCuidamos: TecuidamosService,
    private teCuidamosHelper: TeCuidamosHelper,
    private mmobileHelper: MMobileHelperService,
  ) {}

  ngOnInit() {
    this.teCuidamosSavia = this.mmobileHelper.checkIsFeatureEnabled(AllFeatureFlags.TECUIDAMOS_SAVIA);

    this.teCuidamos
      .getState$()
      .subscribe(state => (this.teCuidamosState = state));
    this.getCardImage();

    this.user = this.auth.getState().user;
  }

  navTo(type: string) {
    this.navigateTo.emit(type);
  }

  private getCardImage() {
    this.cardImageFrontSafeResource = this.teCuidamosHelper.getImage(
      this.teCuidamosState.front
    );
  }

  onOpenSaviaTecuidamos(page: string) {
    this.teCuidamosHelper.openSaviaTeCuidamosUrl(page);
  }
}
